import React from 'react';
import PropTypes from 'prop-types';

import BasicDialog from 'shared/components/feedback/BasicDialog';

const DeleteModal = ({ onConfirm, onCancel, title }) => (
  <BasicDialog
    title={title || 'Are you sure you want to delete?'}
    open
    confirmText="Confirm"
    handleConfirm={onConfirm}
    handleCancel={onCancel}
  />
);

DeleteModal.propTypes = {
  onConfirm: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
  title: PropTypes.string,
};

export default DeleteModal;
